import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { ResponsiveImage } from "@quintype/components";
import { isValidUrl } from "../../../../utils/html-utils";

import "./PartnershipSection.m.css";

const PartnershipSection = ({ titleElement, galleryElement, useBrandColour = false }) => {
  const title = get(titleElement, ["text"], "In partnership with");
  const partnerImages = get(galleryElement, ["story-elements"], []);

  if (!partnerImages || partnerImages.length === 0) {
    return null;
  }

  return (
    <div styleName={`partnership-section ${useBrandColour ? "brand-colour-section" : ""}`}>
      <div styleName="partnership-title">{title}</div>
      <div styleName="partners-row">
        {partnerImages.map((image, index) => {
          const imageKey = get(image, ["image-s3-key"], "");
          const imageMetadata = get(image, ["image-metadata"], {});
          const altText = get(image, ["alt-text"], "Partner logo");
          const hyperlink = get(image, ["hyperlink"], "") || get(image, ["metadata", "hyperlink"], "");
          const isValidHyperlink = isValidUrl(hyperlink);

          if (!imageKey) return null;

          const imageElement = (
            <ResponsiveImage
              slug={imageKey}
              metadata={imageMetadata}
              aspectRatio={[4, 1]}
              defaultWidth={124}
              widths={[124, 248]}
              imgParams={{ auto: ["format", "compress"] }}
              alt={altText}
            />
          );

          return (
            <div key={image.id || index} styleName="partner-logo">
              {isValidHyperlink ? (
                <a
                  href={hyperlink}
                  target="_blank"
                  rel="noopener"
                  styleName="partner-link"
                  aria-label={altText}
                >
                  {imageElement}
                </a>
              ) : (
                imageElement
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

PartnershipSection.propTypes = {
  titleElement: PropTypes.object,
  galleryElement: PropTypes.object,
  useBrandColour: PropTypes.bool,
};

export default PartnershipSection;
